export default __webpack_public_path__ + "static/media/say-by-logo.d9a0c33a.png";